<template>
  <section class="py-6">
    <h1>Collections</h1>
  </section>
</template>
